import { create } from 'zustand';
import type { PendingDetailAction } from '@/components/web/detailPendingAction';

type WebModalStore = {
  showNotInterestSubmitModal: boolean;
  setShowNotInterestSubmitModal: (showNotInterestSubmitModal: boolean) => void;
  showFlowGuideModal: boolean;
  setShowFlowGuideModal: (showFlowGuideModal: boolean) => void;
  showContactInformationModal: boolean;
  setShowContactInformationModal: (
    showContactInformationModal: boolean
  ) => void;
  showSelectInvitedOrderModal: boolean;
  setShowSelectInvitedOrderModal: (
    showSelectInvitedOrderModal: boolean
  ) => void;
  showModalJoinSuccess: boolean;
  setShowModalJoinSuccess: (showModalJoinSuccess: boolean) => void;
  showModalMissOut: boolean;
  setShowModalMissOut: (showModalMissOut: boolean) => void;
  showModalAnalysis: boolean;
  setShowModalAnalysis: (showModalAnalysis: boolean) => void;
  showModalSelectInvitedOrderByNoMatch: boolean;
  setShowModalSelectInvitedOrderByNoMatch: (
    showModalSelectInvitedOrderByNoMatch: boolean
  ) => void;
  showModalSelectInvitedOrderByNoMatchType: 'success' | 'noMatch';
  setShowModalSelectInvitedOrderByNoMatchType: (
    showModalSelectInvitedOrderByNoMatchType: 'success' | 'noMatch'
  ) => void;
  //
  showModalShowImage: boolean;
  modalImageUrl: string;
  setShowModalShowImage: (showModalShowImage: boolean, url?: string) => void;
  //
  showModalTakeOrder: boolean; // PC端 接单总弹窗
  setShowModalTakeOrder: (showModalTakeOrder: boolean) => void;
  showModalConfirmDealPrice: boolean;
  setShowModalConfirmDealPrice: (showModalConfirmDealPrice: boolean) => void;
  showModalSubmitInterest: boolean;
  setShowModalSubmitInterest: (showModalSubmitInterest: boolean) => void;
  showModalWithdrawThisCollaboration: boolean;
  setShowModalWithdrawThisCollaboration: (
    showModalWithdrawThisCollaboration: boolean,
    withDrawOrderId: string
  ) => void;
  withDrawOrderId: string;
  setWithDrawOrderId: (withDrawOrderId: string) => void;
  showModalDealWithdrawn: boolean;
  setShowModalDealWithdrawn: (showModalDealWithdrawn: boolean) => void;
  skipScript: boolean;
  setSkipScript: (skipScript: boolean) => void;
  isAgree: boolean;
  setIsAgree: (isAgree: boolean) => void;
  isShowAgreement: boolean;
  setIsShowAgreement: (isShowAgreement: boolean) => void;
  isShowAddressModal: boolean;
  setShowAddressModal: (isShowAddressModal: boolean) => void;
  isShowImModal: boolean;
  setShowImModal: (isShowImModal: boolean) => void;
  imNum: number;
  setImNum: (imNum: number) => void;
  showEducationModal: boolean;
  setEducationModal: (showEducationModal: boolean, educationInfo: any) => void;
  educationInfo: any;
  //
  showModalSetPaymentMethod: boolean;
  setShowModalSetPaymentMethod: (showModalSetPaymentMethod: boolean) => void;
  showAuthorizationCode: boolean;
  setShowAuthorizationCode: (showAuthorizationCode: boolean) => void;
  agreeProductShip: boolean;
  setAgreeProductShip: (agreeProductShip: boolean) => void;
  productShippingCountry: string;
  setProductShippingCountry: (productShippingCountry: string) => void;
  showModalPublishTime: boolean;
  setShowModalPublishTime: (showModalPublishTime: boolean) => void;
  showPromotionalLinkEducationModal: boolean;
  setShowPromotionalLinkEducationModal: (
    showPromotionalLinkEducationModal: boolean
  ) => void;
  // 邮箱验证弹窗开关
  showModalEmailVerification: boolean;
  setShowModalEmailVerification: (showModalEmailVerification: boolean) => void;
  // 本轮刷新周期是否关闭过邮箱验证弹窗
  closeModalEmailVerification: boolean;
  setCloseModalEmailVerification: (
    closeModalEmailVerification: boolean
  ) => void;
  // 是否申请过订单
  hasAppliedOrder: boolean;
  setHasAppliedOrder: (hasAppliedOrder: boolean) => void;
  // 是否验证了邮件
  firstApplyVerifyEmailVerified: boolean;
  setFirstApplyVerifyEmailVerified: (
    firstApplyVerifyEmailVerified: boolean
  ) => void;
  // 当前节点完成 提示弹窗 （bonus版）
  showModalBonusNext: boolean;
  setShowModalBonusNext: (showModalBonusNext: boolean) => void;
  // 当前节点完成后的提示弹窗（无bonus版）
  showModalNodeSuccess: boolean;
  setShowModalNodeSuccess: (showModalNodeSuccess: boolean) => void;
  // 当前节点, 用来判断上面两个弹窗展示什么内容
  nowSuccessNode: string;
  setNowSuccessNode: (nowSuccessNode: string) => void;
  // 不匹配提示弹窗
  modalNotMatchInfo: {
    visible: boolean;
    message: string;
  };
  setModalNotMatchInfo: (modalNotMatchInfo: {
    visible: boolean;
    message: string;
  }) => void;
  // 拒绝弹窗开关
  showModalRefuseCampaign: boolean;
  setShowModalRefuseCampaign: (showModalRefuseCampaign: boolean) => void;
  // 软删订单提示弹窗
  showModalSoftDeleteTip: boolean;
  setShowModalSoftDeleteTip: (showModalSoftDeleteTip: boolean) => void;
  // 软删原因
  softDeleteReason: string;
  setSoftDeleteReason: (softDeleteReason: string) => void;
  pendingDetailAction: PendingDetailAction;
  setPendingDetailAction: (pendingDetailAction: PendingDetailAction) => void;
  clearPendingDetailAction: () => void;
  // AI review 读秒
  aiReviewElapsedSeconds: number;
  setAiReviewElapsedSeconds: (aiReviewElapsedSeconds: number) => void;
  resetAiReviewElapsedSeconds: () => void;
  resetAiReviewContext: () => void;
  aiReviewSubmitStatus: string;
  aiReviewLink: string;
  setAiReviewContext: (submitStatus: string, link: string) => void;
  // 接受AhaPicks报价弹窗 & 不能议价的标识
  showModalAcceptAhaPicksOffer: boolean;
  setShowModalAcceptAhaPicksOffer: (
    showModalAcceptAhaPicksOffer: boolean
  ) => void;
  openAcceptAhaPicksOfferConfirmDealPrice: () => void;
  pendingAcceptAhaPicksOfferAfterAnalysis: boolean;
  setPendingAcceptAhaPicksOfferAfterAnalysis: (
    pendingAcceptAhaPicksOfferAfterAnalysis: boolean
  ) => void;
  // 是不是本次上传的受众截图
  thisLoading: boolean;
  setThisLoading: (thisLoading: boolean) => void;
  // 接单弹窗内轮询/获取到的受众信息
  takeOrderAudienceView: any | null;
  setTakeOrderAudienceView: (takeOrderAudienceView: any | null) => void;
  deliveryContent: any[]; // 时间线中包含的节点信息（不包括延期内容）
  setDeliveryContent: (deliveryContent: any[]) => void;
};

export const useWebModalStore = create<WebModalStore>()((set) => ({
  showNotInterestSubmitModal: false,
  setShowNotInterestSubmitModal: (showNotInterestSubmitModal: boolean) =>
    set({ showNotInterestSubmitModal }),
  showFlowGuideModal: false,
  setShowFlowGuideModal: (showFlowGuideModal: boolean) =>
    set({ showFlowGuideModal }),
  showContactInformationModal: false,
  setShowContactInformationModal: (showContactInformationModal: boolean) =>
    set({ showContactInformationModal }),
  showSelectInvitedOrderModal: false,
  setShowSelectInvitedOrderModal: (showSelectInvitedOrderModal: boolean) =>
    set({ showSelectInvitedOrderModal }),
  showModalJoinSuccess: false,
  setShowModalJoinSuccess: (showModalJoinSuccess: boolean) =>
    set({ showModalJoinSuccess }),
  showModalMissOut: false,
  setShowModalMissOut: (showModalMissOut: boolean) => set({ showModalMissOut }),
  showModalAnalysis: false,
  setShowModalAnalysis: (showModalAnalysis: boolean) =>
    set({ showModalAnalysis }),
  showModalSelectInvitedOrderByNoMatch: false,
  setShowModalSelectInvitedOrderByNoMatch: (
    showModalSelectInvitedOrderByNoMatch: boolean
  ) => set({ showModalSelectInvitedOrderByNoMatch }),
  showModalSelectInvitedOrderByNoMatchType: 'noMatch' as const,
  setShowModalSelectInvitedOrderByNoMatchType: (
    showModalSelectInvitedOrderByNoMatchType: 'success' | 'noMatch'
  ) => set({ showModalSelectInvitedOrderByNoMatchType }),
  showModalTakeOrder: false,
  setShowModalTakeOrder: (showModalTakeOrder: boolean) =>
    set({ showModalTakeOrder }),
  showModalConfirmDealPrice: false,
  setShowModalConfirmDealPrice: (showModalConfirmDealPrice: boolean) =>
    set({ showModalConfirmDealPrice }),
  showModalSubmitInterest: false,
  // 接受AhaPicks报价弹窗 & 不能议价的标识
  showModalAcceptAhaPicksOffer: false,
  setShowModalAcceptAhaPicksOffer: (showModalAcceptAhaPicksOffer: boolean) =>
    set({ showModalAcceptAhaPicksOffer }),
  openAcceptAhaPicksOfferConfirmDealPrice: () =>
    set({
      showModalAcceptAhaPicksOffer: true,
      showModalConfirmDealPrice: true
    }),
  pendingAcceptAhaPicksOfferAfterAnalysis: false,
  setPendingAcceptAhaPicksOfferAfterAnalysis: (
    pendingAcceptAhaPicksOfferAfterAnalysis: boolean
  ) => set({ pendingAcceptAhaPicksOfferAfterAnalysis }),
  setShowModalSubmitInterest: (showModalSubmitInterest: boolean) =>
    set({ showModalSubmitInterest }),
  // 撤回申请弹窗
  showModalWithdrawThisCollaboration: false,
  setShowModalWithdrawThisCollaboration: (
    showModalWithdrawThisCollaboration: boolean,
    withDrawOrderId: string
  ) => {
    if (showModalWithdrawThisCollaboration) {
      set({ showModalWithdrawThisCollaboration, withDrawOrderId });
    } else {
      set({ showModalWithdrawThisCollaboration: false, withDrawOrderId: '' });
    }
  },
  withDrawOrderId: '',
  setWithDrawOrderId: (withDrawOrderId: string) => set({ withDrawOrderId }),
  showModalDealWithdrawn: false,
  setShowModalDealWithdrawn: (showModalDealWithdrawn: boolean) =>
    set({ showModalDealWithdrawn }),
  //
  //
  showModalShowImage: false,
  modalImageUrl: '',
  setShowModalShowImage: (showModalShowImage: boolean, url?: string) =>
    set({ showModalShowImage, modalImageUrl: url }),
  //
  skipScript: false,
  setSkipScript: (skipScript: boolean) => set({ skipScript }),
  isAgree: false,
  setIsAgree: (isAgree: boolean) => set({ isAgree }),
  isShowAgreement: false,
  setIsShowAgreement: (isShowAgreement: boolean) => set({ isShowAgreement }),
  isShowAddressModal: false,
  setShowAddressModal: (isShowAddressModal: boolean) =>
    set({ isShowAddressModal }),
  isShowImModal: false,
  setShowImModal: (isShowImModal: boolean) => set({ isShowImModal }),
  // imNum
  imNum: 0,
  setImNum: (imNum: number) => set({ imNum }),
  showEducationModal: false,
  setEducationModal: (showEducationModal: boolean, educationInfo: any) =>
    set({ showEducationModal, educationInfo }),
  educationInfo: {},
  //
  showModalSetPaymentMethod: false,
  setShowModalSetPaymentMethod: (showModalSetPaymentMethod: boolean) =>
    set({ showModalSetPaymentMethod }),
  showAuthorizationCode: false,
  setShowAuthorizationCode: (showAuthorizationCode: boolean) =>
    set({ showAuthorizationCode }),
  agreeProductShip: false,
  setAgreeProductShip: (agreeProductShip: boolean) => set({ agreeProductShip }),
  productShippingCountry: '',
  setProductShippingCountry: (productShippingCountry: string) =>
    set({ productShippingCountry }),
  showModalPublishTime: false,
  setShowModalPublishTime: (showModalPublishTime: boolean) =>
    set({ showModalPublishTime }),
  showPromotionalLinkEducationModal: false,
  setShowPromotionalLinkEducationModal: (
    showPromotionalLinkEducationModal: boolean
  ) => set({ showPromotionalLinkEducationModal }),
  showModalEmailVerification: false,
  setShowModalEmailVerification: (showModalEmailVerification: boolean) =>
    set({ showModalEmailVerification }),
  closeModalEmailVerification: false,
  setCloseModalEmailVerification: (closeModalEmailVerification: boolean) =>
    set({ closeModalEmailVerification }),
  hasAppliedOrder: false,
  setHasAppliedOrder: (hasAppliedOrder: boolean) => set({ hasAppliedOrder }),
  firstApplyVerifyEmailVerified: false,
  setFirstApplyVerifyEmailVerified: (firstApplyVerifyEmailVerified: boolean) =>
    set({ firstApplyVerifyEmailVerified }),
  showModalBonusNext: false,
  setShowModalBonusNext: (showModalBonusNext: boolean) =>
    set({ showModalBonusNext }),
  showModalNodeSuccess: false,
  setShowModalNodeSuccess: (showModalNodeSuccess: boolean) =>
    set({ showModalNodeSuccess }),
  nowSuccessNode: '',
  setNowSuccessNode: (nowSuccessNode: string) => set({ nowSuccessNode }),
  setModalNotMatchInfo: (modalNotMatchInfo: {
    visible: boolean;
    message: string;
  }) => set({ modalNotMatchInfo }),
  modalNotMatchInfo: { visible: false, message: '' } as {
    visible: boolean;
    message: string;
  },
  showModalRefuseCampaign: false,
  setShowModalRefuseCampaign: (showModalRefuseCampaign: boolean) =>
    set({ showModalRefuseCampaign }),
  showModalSoftDeleteTip: false,
  setShowModalSoftDeleteTip: (showModalSoftDeleteTip: boolean) =>
    set({ showModalSoftDeleteTip }),
  softDeleteReason: '',
  setSoftDeleteReason: (softDeleteReason: string) => set({ softDeleteReason }),
  pendingDetailAction: null,
  setPendingDetailAction: (pendingDetailAction: PendingDetailAction) =>
    set({ pendingDetailAction }),
  clearPendingDetailAction: () => set({ pendingDetailAction: null }),
  aiReviewElapsedSeconds: 0,
  setAiReviewElapsedSeconds: (aiReviewElapsedSeconds: number) =>
    set({ aiReviewElapsedSeconds }),
  resetAiReviewElapsedSeconds: () => set({ aiReviewElapsedSeconds: 0 }),
  resetAiReviewContext: () =>
    set({ aiReviewSubmitStatus: '', aiReviewLink: '' }),
  aiReviewSubmitStatus: '',
  aiReviewLink: '',
  setAiReviewContext: (submitStatus: string, link: string) =>
    set({ aiReviewSubmitStatus: submitStatus, aiReviewLink: link }),
  thisLoading: false,
  setThisLoading: (thisLoading: boolean) => set({ thisLoading }),
  takeOrderAudienceView: null,
  setTakeOrderAudienceView: (takeOrderAudienceView: any | null) =>
    set({ takeOrderAudienceView }),
  deliveryContent: [],
  setDeliveryContent: (deliveryContent: any[]) => set({ deliveryContent })
}));
